import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-748c9ccb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "input-file" }
const _hoisted_2 = { class: "container-input" }
const _hoisted_3 = { class: "container-text" }
const _hoisted_4 = { class: "text-input-file" }
const _hoisted_5 = {
  class: "text-downloaded",
  for: "downloaded",
  tabindex: "0"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  class: "input",
  type: "file",
  name: "file",
  id: "downloaded",
  multiple: ""
}, null, -1))
const _hoisted_7 = { class: "text-max-size" }
const _hoisted_8 = {
  key: 0,
  class: "wrap-downloaded-files"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DownloadedFiles = _resolveComponent("DownloadedFiles")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", null, _toDisplayString(_ctx.t('fileInput.title')), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Icon, {
          class: "icon-download",
          spriteUrl: "/image/videoconf-icons.svg",
          name: "ic25-download"
        }),
        _createElementVNode("p", _hoisted_4, [
          _createTextVNode(_toDisplayString(_ctx.t('fileInput.input')), 1),
          _createElementVNode("label", _hoisted_5, [
            _createTextVNode(_toDisplayString(_ctx.t('fileInput.browse')), 1),
            _hoisted_6
          ])
        ])
      ]),
      _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.t('fileInput.maxSize')), 1)
    ]),
    (_ctx.isDefault)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          false
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                class: "text-delete-all",
                size: "s",
                mode: "flat"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('fileInput.delete')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_DownloadedFiles),
          _createVNode(_component_DownloadedFiles)
        ]))
      : _createCommentVNode("", true)
  ]))
}